import { memo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const PIDatePicker = memo((props) => {
  return <DatePicker {...props} />;
});
